export function formatToPrettyDate(date?: string) {
  if (!date) return ''

  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

  // Extract date and time parts
  const [year, month, day] = date.split('-').map(Number)

  // Create date objects
  const startDate = new Date(year, month - 1, day)

  // Format the output
  const dayOfWeek = days[startDate.getDay()]
  const monthName = months[startDate.getMonth()]
  const formattedDay = startDate.getDate()

  return `${dayOfWeek}, ${monthName} ${formattedDay}`
}
